/* istanbul ignore file: we do not need to care about the entry point file as errors are detected through integration tests (E2E) */ import { handleCorruptRestApi } from "@devowl-wp/utils";
import { listenScannerJobExecution, listenScannerStatus, listenAutomaticScanStarterJobExecution } from "./others";
/**
 * The entry point for the `real-queue` workers
 */ handleCorruptRestApi({
});
listenScannerJobExecution();
listenScannerStatus();
listenAutomaticScanStarterJobExecution();
